// extracted by mini-css-extract-plugin
module.exports =  {"infoBody":"filtersInfo-module_infoBody_d7371","textBlock":"filtersInfo-module_textBlock_ee1df"};